export default __webpack_public_path__ + "static/media/storage_size_4.c714a880.png";